
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./ideAITutorRemoteEntry": () => {
return Promise.all([__webpack_require__.e(16294), __webpack_require__.e(5488), __webpack_require__.e(32624), __webpack_require__.e(16818), __webpack_require__.e(45964), __webpack_require__.e(75303), __webpack_require__.e(42001), __webpack_require__.e(81716), __webpack_require__.e(71428), __webpack_require__.e(52856), __webpack_require__.e(44029)]).then(() => (() => (__webpack_require__(340460))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };